module.exports = __webpack_public_path__ + "img/icon_07.36e6526c.png";